
export default function SpeakingSection() {
  return (
    <section id="speaking" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold border-l-4 border-teal-500 pl-4 mb-10">
          Keynote Speaking & Courses
        </h2>
        
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900">Transform Your Organization's Decision-Making</h3>
            <p className="text-lg text-gray-700">
              Alberto delivers powerful keynotes and workshops that help organizations understand and implement the principles of the Consistency Paradox. Learn how AI can serve as a mirror to improve human decision-making processes.
            </p>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-presentation-line text-teal-600 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Corporate Keynotes</h4>
                  <p className="text-gray-600">60-90 minute presentations for leadership teams and conferences</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-team-line text-teal-600 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Executive Workshops</h4>
                  <p className="text-gray-600">Half-day intensive sessions with practical implementation strategies</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-graduation-cap-line text-teal-600 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold text-gray-900">Academic Courses</h4>
                  <p className="text-gray-600">University lectures and research collaboration opportunities</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/0b2a9856f45287571b4712bc4b3f5258.jpg"
              alt="Alberto Rocha Speaking at Conference" 
              className="rounded-xl shadow-lg object-top"
            />
          </div>
        </div>

        {/* Speaking Topics */}
        <div className="space-y-8 mb-16">
          <h3 className="text-2xl font-bold text-gray-900">Popular Speaking Topics</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            
            <div className="bg-gray-50 p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <h4 className="text-xl font-bold text-gray-900 mb-3">The Consistency Paradox</h4>
              <p className="text-gray-700">
                How AI's consistent behavior reveals the structural flaws in human decision-making and what we can learn from it.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <h4 className="text-xl font-bold text-gray-900 mb-3">Ethical AI Implementation</h4>
              <p className="text-gray-700">
                Practical frameworks for implementing AI systems that enhance rather than replace human moral judgment.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <h4 className="text-xl font-bold text-gray-900 mb-3">Bias in Human Systems</h4>
              <p className="text-gray-700">
                Lessons from decades of fighting discrimination in government and corporate environments.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <h4 className="text-xl font-bold text-gray-900 mb-3">Future of Work & AI</h4>
              <p className="text-gray-700">
                How organizations can prepare for a future where AI and humans collaborate more effectively.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <h4 className="text-xl font-bold text-gray-900 mb-3">Leadership in the AI Age</h4>
              <p className="text-gray-700">
                What leaders need to know about making decisions in an era of artificial intelligence.
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl shadow-md border-t-4 border-teal-500">
              <h4 className="text-xl font-bold text-gray-900 mb-3">Technology & Civil Rights</h4>
              <p className="text-gray-700">
                The intersection of technology advancement and social justice in modern organizations.
              </p>
            </div>

          </div>
        </div>

        {/* Testimonials */}
        <div className="space-y-8 mb-16">
          <h3 className="text-2xl font-bold text-gray-900">What Audiences Say</h3>
          <div className="grid md:grid-cols-2 gap-8">
            
            <div className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-teal-500">
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-4 italic">
                "Alberto's presentation on the Consistency Paradox completely changed how our leadership team thinks about AI implementation. His insights are both profound and practical."
              </p>
              <div className="text-sm">
                <p className="font-semibold text-gray-900">Sarah Chen</p>
                <p className="text-gray-600">Chief Technology Officer, Fortune 500 Company</p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-teal-500">
              <div className="flex items-center space-x-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-4 italic">
                "Rarely have I seen a speaker bridge the gap between academic research and real-world application so effectively. Alberto's work is groundbreaking."
              </p>
              <div className="text-sm">
                <p className="font-semibold text-gray-900">Dr. Michael Rodriguez</p>
                <p className="text-gray-600">Director of AI Ethics, Tech Innovation Institute</p>
              </div>
            </div>

          </div>
        </div>

        {/* Booking CTA */}
        <div className="text-center">
          <div className="bg-gray-900 text-white p-8 rounded-xl shadow-lg max-w-3xl mx-auto">
            <h3 className="text-3xl font-bold mb-4">Ready to Book Alberto?</h3>
            <p className="text-xl text-gray-300 mb-6">
              Transform your organization's understanding of AI and human decision-making. Available for keynotes, workshops, and consulting engagements worldwide.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6 justify-center">
              <button className="bg-teal-500 hover:bg-teal-600 text-gray-900 font-bold py-3 px-8 rounded-full shadow-lg text-lg transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer">
                Book Speaking Engagement
              </button>
              <button className="bg-gray-700 hover:bg-gray-600 text-white font-semibold py-3 px-8 rounded-full text-lg transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer">
                Download Speaker Kit
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
